import { UIFlightData } from "@flights/types";
import { createTrackingUtils } from "../index";
import { isOfMetaOrigin } from "../../marketing-url-params";
import { useRef } from "react";
import useIsInViewport from "../../../hooks/useIsInViewport";
import { getFlightDetailsFetchStatus } from "../../../store/flightDetails/selectors";
import { useSelector } from "react-redux";

const utils = createTrackingUtils({
  name: "flights_apex_web_show_included_baggage_asap",
  stages: {
    flight_details: 1,
    main: 2,
    ddot: 3,
    mdot: 4,
    extras_not_loaded_clicked_next: 5,
    no_baggage_in_extras: 6,
    baggage_in_extras_seen: 7,
    baggage_in_extras_not_seen: 8,
    loader_visible_without_scroll: 9
  },
  goals: {},
  defaultStage: 2
});

interface TrackStagesParams {
  isMobile: boolean;
  flight: UIFlightData;
}

const useTrackStages = ({ isMobile, flight }: TrackStagesParams) => {
  const loaderRef = useRef<HTMLDivElement>(null);
  const loaderInViewport = useIsInViewport(loaderRef);

  utils.stages.flight_details();

  if (!isEligible(flight)) return;

  utils.stages.main();

  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.ddot();
  if (loaderInViewport && window.scrollY === 0) utils.stages.loader_visible_without_scroll();

  return loaderRef;
};

const useTrackStagesExtras = (showExtraBaggage?: boolean) => {
  const fetchStatus = useSelector(getFlightDetailsFetchStatus);
  const extrasRef = useRef<HTMLElement | null>(null);
  const extrasInViewport = useIsInViewport(extrasRef);

  if (fetchStatus !== "success") return;

  if (!showExtraBaggage) {
    utils.stages.no_baggage_in_extras();
    return extrasRef;
  }

  if (extrasInViewport) {
    utils.stages.baggage_in_extras_seen();
  } else {
    utils.stages.baggage_in_extras_not_seen();
  }

  return extrasRef;
};

const isEligible = (flight: UIFlightData) =>
  !isOfMetaOrigin() && flight.includedProducts?.segments.some((product) => product.length > 0);

export default { ...utils, useTrackStages, isEligible, useTrackStagesExtras };
